import { render, staticRenderFns } from "./painSpot_add.vue?vue&type=template&id=7f57dc76&scoped=true"
import script from "./painSpot_add.vue?vue&type=script&lang=js"
export * from "./painSpot_add.vue?vue&type=script&lang=js"
import style0 from "./painSpot_add.vue?vue&type=style&index=0&id=7f57dc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f57dc76",
  null
  
)

export default component.exports